import { BaseImage, BaseImageProps } from '@components/BaseImage'
import { useLocale } from '@hooks/useLocale'
import getRegionFromLocale, { Region } from '@lib/utils/getRegionFromLocale'
import { memo } from 'react'

const DEFAULT_IMAGE = '/img/default-cover.png'

export const STATIC_RESOURCE_HOSTS = {
  [Region.NORWAY]: 'https://static-no.bookis.com',
  [Region.SWEDEN]: 'https://static-se.bookis.com'
} as const

export const getImageSource = (src: string | BaseImageProps['src'], region: Region) => {
  const isResourcePath = typeof src === 'string' && !src.startsWith('/') && src.includes('/')
  const isUrl = typeof src === 'string' && src.startsWith('http')

  if (isUrl) {
    return { isHosted: true, source: src }
  }
  if (isResourcePath) {
    return { isHosted: true, source: `${STATIC_RESOURCE_HOSTS[region]}/${src}` }
  }
  return { isHosted: false, source: '' }
}

const BookImage = memo((props: Omit<BaseImageProps, 'fallbackImageSrc'>) => {
  const locale = useLocale()
  const region = getRegionFromLocale(locale)
  const { src, ...restProps } = props

  const imageSource = getImageSource(src, region) || { source: DEFAULT_IMAGE } // Fallback to default image if imageSource is undefined

  const newProps = {
    ...restProps,
    src: imageSource.source || DEFAULT_IMAGE // Ensure src is never undefined
  }

  return <BaseImage {...newProps} fallbackImageSrc={DEFAULT_IMAGE} />
})

export default BookImage
